import React from "react";
import * as styles from "./styles.mod.scss";
import Link from "components/link";
import { Container } from "react-bootstrap";
import Instagram from "assets/svgs/instagram.svg";
import Web from "assets/svgs/web.svg";
import Youtube from "assets/svgs/youtube.svg";
import Verified from "assets/svgs/verifizert.svg";
import getImagePath from "helpers/get-image-path";

const RecipeAuthor = ({ author, container, recipePage }) => {

  return container == true ? (
    <Container>
      <div className={`${styles.recipeAuthor} ${styles.headRecipeAuthor}`}>
        <img src={getImagePath(author?.image)} className={styles.headAuthorImg} alt={author?.image?.alt} />
        <div className={styles.headAuthorName}>
          <h3 className={styles.authorName}>{author?.title}<Verified /></h3>
          <p className={styles.authorPosition}>{author?.position}</p>
          <p className={styles.authorDescription}>{author?.bio}</p>
          <div className={styles.authorSocialMedia}>
            {author?.website &&
              <div className={styles.socialIcons}><Link to={`https://${author?.website}`}><Web />{author?.website}</Link></div>}
            {author?.instagram &&
              <div className={styles.socialIcons}><Link to={`https://instagram.com/${author?.instagram}`}><Instagram />{author?.instagram}</Link></div>}
            {author?.youtube &&
              <div className={styles.socialIcons}><Link to={`https://youtube.com/${author?.youtube}`}><Youtube />{author?.youtube}</Link></div>}
          </div>
        </div>
      </div>
    </Container>
  ) : (
    <div className={`${styles.recipeAuthor} ${recipePage == true && styles.recipePageBox}`}>
      <img src={getImagePath(author?.image)} className={styles.authorImg} alt={author?.image?.alt} />
      <div className={styles.authorInfo}>
        <h5 className={styles.authorName}>{author?.title}</h5>
        <p className={styles.authorPosition}>{author?.position}</p>
      </div>
    </div>

  );
};

export default RecipeAuthor;